let baseUrl = '/' // 'http://121.199.62.174:52891/'

const VERSION = process.APP_VARIABLES.VERSION

let config = {
  VERSION,
  BASE_URL: baseUrl,
  API_URL: `${baseUrl}api/`,
  SYSTEM_TITLE: '台席业务系统',
  SYSTEM_SUB_TITLE: '上海恩谷养老服务信息网络平台'
}
export default config
